module.exports = new __parcel__URL__("browser3.b317f175.png").toString();